import {useTranslation, withTranslation} from "react-i18next";
import "./rotatedevice.scss"

function RotateDevice({className = ''}) {
    const { t, i18n } = useTranslation();
    return (
      <div className={"container-rotate-device boxed"}>
          <img className={"rotate-device__img"}/>
          <p className={"rotate-device__text"}>{t("rotatedevicetext")}</p>
      </div>
    );
}
export default withTranslation()(RotateDevice);
